import React, { useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { v4 as uuid } from 'uuid';

import { InfoMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { Link, LinkType } from '@eika/link';

import { Assets } from '../../assets';
import ProductImage from '../ProductImage/ProductImage';

import './Message.scss';

interface Props {
    title?: string;
    text?: string[];
    link?: string;
    linkText?: string;
    infoBox?: string;
    image?: Assets;
}

const Message = ({ title, text, link, linkText, infoBox, image = 'Stop' }: Props): JSX.Element => {
    useEffect(() => {
        scroll.scrollToTop();
    }, []);
    return (
        <div className="message">
            <div className="sgw-layout medium-centered-container">
                <div className="sgw-layout-item sgw-layout-item__full-width">
                    {title && <ProductImage className="messages__header" image={image} title={title} />}

                    <div className="message__content">{text && text.map((t) => <p key={uuid()}>{t}</p>)}</div>

                    {link && (
                        <div className="message__cta">
                            <Link href={link} linkType={LinkType.BUTTON_STANDARD_POSITIVE}>
                                {linkText}
                            </Link>
                        </div>
                    )}

                    {infoBox && <InfoMessage className="message__info" text={infoBox} icon={IconTypes.LYSPAERE_24} />}
                </div>
            </div>
        </div>
    );
};

export default Message;
